<!-- Sign up layout wrapped with sidenav container -->
<mat-sidenav-container class="verification-sidenav-container">
  <mat-sidenav
    #verificationSidenav
    [mode]="'over'"
    position="end"
    [disableClose]="true"
    [fixedInViewport]="true"
    [fixedTopGap]="0"
    [fixedBottomGap]="0"
    class="verification-sidenav"
  >
    <div *ngIf="verifyStep && !isSmallViewport" class="sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <!-- Close button -->
      <button
        *ngIf="!isVerifyRoute"
        mat-icon-button
        class="sidenav-close-btn"
        (click)="onCloseSidenav()"
        type="button"
        aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 16 16">
          <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button>

      <!-- Verification Component -->
      <app-verification
        [isVerifyRoute]="isVerifyRoute"
        [inlineRegistrationCycleLogId]="inlineRegistrationCycleLogIdForVerification"
        [inlineUser]="inlineUserForVerification"
        [inlineVerifyType]="verificationData?.verifyType"
        (closeSidebar)="onCloseSidebarFromVerification()"
      ></app-verification>
    </div>

    <!-- Reset Password -->
    <div *ngIf="resetStep" class="sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <!-- <button
        mat-icon-button
        class="sidenav-close-btn"
        (click)="onCloseResetSidenav()"
        type="button"
        aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 16 16">
          <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
        </svg>
      </button> -->
      <app-reset-password></app-reset-password>
    </div>

    <!-- Terms & Conditions / Privacy Policy -->
    <div *ngIf="termsStep" class="sidenav-content terms-sidenav-content" fxLayout="column" fxLayoutAlign="start stretch">
      <div class="terms-header">
        <button
          mat-icon-button
          class="sidenav-close-btn"
          (click)="onCloseTermsSidenav()"
          type="button"
          aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 16 16">
            <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" stroke-width="2"/>
          </svg>
        </button>
        <h3 class="terms-title">
          {{ 'terms_and_conditions' | translate }}
        </h3>
      </div>
      <app-terms-condition></app-terms-condition>
    </div>
  </mat-sidenav>

  <!-- Main sign-up content -->
  <mat-sidenav-content>
    <!-- Small screens: verification as full main content with logo + watch video + language (not sidenav) -->
    <div
      *ngIf="showVerificationInline"
      class="sign-up-inline-verification"
      fxLayout="column"
      fxLayoutAlign="center stretch"
    >
      <header
        class="sign-up-mobile-top-bar"
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxLayoutGap="12px"
      >
        <svg width="91" height="17" viewBox="0 0 91 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.6722 16.4644C20.8848 16.4634 21.095 16.4226 21.291 16.3445C21.4869 16.2664 21.6647 16.1524 21.8142 16.009C21.9638 15.8657 22.082 15.6958 22.1623 15.5091C22.2426 15.3223 22.2834 15.1224 22.2822 14.9208V1.58938C22.2822 1.18424 22.1126 0.795695 21.8107 0.50922C21.5087 0.222745 21.0992 0.0618046 20.6722 0.0618046C20.2452 0.0618046 19.8357 0.222745 19.5337 0.50922C19.2318 0.795695 19.0622 1.18424 19.0622 1.58938V14.9213C19.0611 15.1229 19.1019 15.3227 19.1822 15.5094C19.2625 15.6961 19.3808 15.8659 19.5303 16.0092C19.6798 16.1525 19.8576 16.2664 20.0536 16.3445C20.2495 16.4226 20.4597 16.4634 20.6722 16.4644ZM10.4581 9.72169L11.7247 10.6931C11.877 10.8095 11.9987 10.958 12.0801 11.1267C12.1615 11.2955 12.2003 11.4799 12.1935 11.6654C12.1867 11.8509 12.1344 12.0323 12.0409 12.1953C11.9473 12.3583 11.815 12.4984 11.6545 12.6044C10.8271 13.1358 9.85028 13.4188 8.8511 13.4164C7.85192 13.4141 6.87659 13.1266 6.05194 12.5913C5.89181 12.4849 5.75995 12.3447 5.66677 12.1817C5.57359 12.0187 5.52164 11.8374 5.51504 11.652C5.50843 11.4667 5.54735 11.2824 5.62872 11.1138C5.71008 10.9452 5.83166 10.7969 5.98385 10.6805L7.82681 9.26803C7.93623 9.18378 8.02445 9.07743 8.08505 8.95673C8.14565 8.83602 8.1771 8.704 8.1771 8.5703C8.1771 8.4366 8.14565 8.30459 8.08505 8.18388C8.02445 8.06318 7.93623 7.95683 7.82681 7.87258L5.88146 6.38483C5.73064 6.26907 5.60989 6.12195 5.52857 5.95484C5.44725 5.78772 5.40752 5.60511 5.41247 5.4211C5.41742 5.2371 5.46691 5.05664 5.55711 4.89368C5.64731 4.73072 5.7758 4.58963 5.93266 4.48132C6.78595 3.89527 7.81293 3.58065 8.86632 3.58257C9.91971 3.58449 10.9454 3.90285 11.7963 4.49201C12.1192 4.72214 12.5135 4.84392 12.9173 4.83821C13.321 4.83249 13.7113 4.6996 14.0268 4.46043L14.1225 4.38661C14.34 4.21671 14.5136 4.00189 14.6302 3.75856C14.7467 3.51523 14.803 3.24985 14.7949 2.98269C14.7867 2.71554 14.7143 2.45369 14.5831 2.21717C14.452 1.98064 14.2655 1.77571 14.0381 1.61803C12.8142 0.766418 11.3802 0.227679 9.8736 0.0535636C8.36703 -0.120552 6.83858 0.0758057 5.43506 0.623776C4.33352 1.03127 3.3355 1.6556 2.50675 2.45563C1.67801 3.25567 1.03735 4.21324 0.626997 5.26526C-1.72789 11.2964 2.88666 16.9987 8.865 16.9987C10.8072 16.9899 12.693 16.3777 14.2338 15.2558C15.7747 14.134 16.8859 12.5641 17.3974 10.7864C17.4703 10.5307 17.4803 10.2625 17.4265 10.0025C17.3727 9.74257 17.2567 9.49783 17.0873 9.28725C16.9179 9.07666 16.6997 8.90587 16.4496 8.78808C16.1995 8.67029 15.9242 8.60866 15.645 8.60795H10.8646C10.7288 8.6094 10.5967 8.65061 10.4864 8.72593C10.3762 8.80126 10.2931 8.90704 10.2486 9.02882C10.2041 9.15061 10.2003 9.28246 10.2377 9.40638C10.2751 9.5303 10.3519 9.64025 10.4576 9.72121M51.5238 4.27295C50.5905 4.14939 49.6395 4.24907 48.7572 4.56293C47.8748 4.87678 47.0891 5.39486 46.4715 6.07009C45.8539 5.3949 45.0682 4.87684 44.1858 4.56299C43.3035 4.24914 42.3525 4.14944 41.4193 4.27295C38.706 4.62558 36.5047 7.18189 36.5047 9.81009V14.6089C36.5047 14.9716 36.6565 15.3194 36.9268 15.5758C37.1971 15.8322 37.5636 15.9762 37.9458 15.9762C38.328 15.9762 38.6945 15.8322 38.9648 15.5758C39.2351 15.3194 39.3869 14.9716 39.3869 14.6089V9.76589C39.3757 9.12006 39.6047 8.49114 40.0338 7.98967C40.4629 7.48821 41.0646 7.1463 41.7331 7.02403C42.1407 6.96 42.5581 6.98122 42.9562 7.08622C43.3542 7.19121 43.7233 7.37743 44.0376 7.63187C44.3519 7.8863 44.6038 8.20281 44.7758 8.55925C44.9477 8.9157 45.0355 9.30347 45.033 9.69546V14.6089C45.033 14.7885 45.0703 14.9663 45.1427 15.1322C45.2151 15.2981 45.3213 15.4488 45.4551 15.5758C45.5889 15.7027 45.7478 15.8034 45.9226 15.8722C46.0974 15.9409 46.2848 15.9762 46.4741 15.9762C46.6633 15.9762 46.8507 15.9409 47.0256 15.8722C47.2004 15.8034 47.3593 15.7027 47.4931 15.5758C47.6269 15.4488 47.733 15.2981 47.8055 15.1322C47.8779 14.9663 47.9152 14.7885 47.9152 14.6089V9.76589C47.9039 9.11996 48.133 8.49094 48.5622 7.98945C48.9914 7.48795 49.5932 7.14611 50.2619 7.02403C50.6694 6.96008 51.0868 6.98136 51.4848 7.08639C51.8828 7.19142 52.2518 7.37765 52.566 7.63208C52.8803 7.88651 53.1322 8.20299 53.3041 8.55939C53.476 8.9158 53.5637 9.30352 53.5613 9.69546V14.6089C53.5576 14.7906 53.5923 14.9712 53.663 15.14C53.7338 15.3089 53.8394 15.4627 53.9735 15.5924C54.1077 15.7221 54.2677 15.8251 54.4443 15.8954C54.6209 15.9658 54.8106 16.002 55.0021 16.002C55.1936 16.002 55.3832 15.9658 55.5598 15.8954C55.7364 15.8251 55.8965 15.7221 56.0307 15.5924C56.1648 15.4627 56.2704 15.3089 56.3411 15.14C56.4119 14.9712 56.4465 14.7906 56.4429 14.6089V9.81009C56.4429 7.18383 54.2416 4.62703 51.5284 4.27295M28.5887 4.38369C27.0608 4.56457 25.6624 5.28933 24.6764 6.41132C23.6903 7.53332 23.1903 8.96878 23.2774 10.4273C23.3644 11.8858 24.0322 13.2585 25.1455 14.2677C26.2588 15.2768 27.7346 15.8471 29.2742 15.8631H29.3766C29.7422 15.853 30.0891 15.7075 30.3429 15.4576C30.5967 15.2077 30.7372 14.8734 30.7342 14.5264V14.4807C30.7353 14.1164 30.584 13.7665 30.3136 13.5078C30.0432 13.2491 29.6756 13.1027 29.2916 13.1008H29.2762C28.6507 13.1071 28.0372 12.9368 27.5139 12.6116C26.9905 12.2864 26.5808 11.8209 26.3368 11.2743C26.0928 10.7278 26.0256 10.1247 26.1435 9.54179C26.2615 8.95886 26.5595 8.42236 26.9995 8.00041C27.4395 7.57847 28.0018 7.29013 28.6149 7.172C29.228 7.05388 29.8643 7.11131 30.4429 7.33699C31.0216 7.56268 31.5164 7.94643 31.8647 8.43953C32.213 8.93262 32.399 9.5128 32.399 10.1064V14.4778C32.3975 14.8291 32.5428 15.1667 32.803 15.4167C33.0631 15.6666 33.4171 15.8086 33.7874 15.8116H33.8831C34.2545 15.8096 34.6099 15.6679 34.8711 15.4174C35.1323 15.1669 35.278 14.8282 35.2761 14.4759V10.1044C35.28 9.29763 35.1043 8.49914 34.7603 7.76129C34.4163 7.02343 33.9119 6.36287 33.2801 5.82288C32.6482 5.2829 31.9033 4.87568 31.094 4.62791C30.2847 4.38014 29.4294 4.29741 28.5841 4.38515M83.4089 4.38515C81.881 4.56605 80.4826 5.29084 79.4965 6.41288C78.5105 7.53493 78.0105 8.97044 78.0976 10.429C78.1848 11.8876 78.8526 13.2603 79.966 14.2694C81.0794 15.2785 82.5553 15.8486 84.0949 15.8645H84.1973C84.5629 15.8545 84.9098 15.7089 85.1636 15.459C85.4174 15.2092 85.5579 14.8749 85.555 14.5278V14.4822C85.556 14.3016 85.5194 14.1227 85.4474 13.9556C85.3754 13.7884 85.2694 13.6364 85.1354 13.5082C85.0014 13.3801 84.842 13.2782 84.6665 13.2086C84.4909 13.1389 84.3026 13.1028 84.1123 13.1023H84.097C83.4714 13.1085 82.858 12.9382 82.3346 12.613C81.8112 12.2878 81.4015 11.8224 81.1575 11.2758C80.9136 10.7292 80.8463 10.1262 80.9643 9.54324C81.0823 8.96032 81.3802 8.42381 81.8202 8.00187C82.2603 7.57993 82.8225 7.29158 83.4356 7.17346C84.0487 7.05534 84.685 7.11277 85.2637 7.33845C85.8423 7.56413 86.3372 7.94789 86.6855 8.44098C87.0338 8.93408 87.2197 9.51425 87.2198 10.1078V14.4793C87.2178 14.8316 87.3635 15.1703 87.6247 15.4208C87.886 15.6713 88.2413 15.813 88.6127 15.815H88.7085C88.8925 15.8138 89.0745 15.7783 89.2441 15.7103C89.4137 15.6424 89.5675 15.5434 89.6967 15.4191C89.826 15.2947 89.9281 15.1474 89.9972 14.9855C90.0664 14.8237 90.1013 14.6505 90.0999 14.4759V10.1044C90.1038 9.29772 89.9281 8.49932 89.5842 7.76154C89.2402 7.02376 88.7359 6.36325 88.1042 5.82328C87.4725 5.28331 86.7277 4.87607 85.9185 4.62823C85.1094 4.38039 84.2542 4.29756 83.4089 4.38515ZM62.5221 4.26178C60.9223 4.4518 59.4582 5.21117 58.4259 6.38633C57.3937 7.56149 56.8703 9.06473 56.9617 10.592C57.0531 12.1193 57.7523 13.5567 58.9181 14.6135C60.0839 15.6703 61.6291 16.2676 63.2414 16.2847C64.2803 16.2832 65.3024 16.0354 66.2147 15.5639C66.4203 15.4584 66.5961 15.3075 66.7271 15.1238C66.8582 14.9402 66.9406 14.7293 66.9675 14.509C66.9944 14.2887 66.9649 14.0655 66.8815 13.8584C66.7981 13.6512 66.6634 13.4661 66.4886 13.3189L66.4706 13.3038C66.2459 13.1214 65.9676 13.0088 65.6733 12.9811C65.379 12.9535 65.0828 13.0122 64.8248 13.1494C64.228 13.4487 63.5506 13.5722 62.8794 13.5039C62.1271 13.3899 61.4313 13.0553 60.8896 12.547C60.3479 12.0387 59.9875 11.3823 59.859 10.6698C59.7444 9.90108 59.9254 9.11891 60.3689 8.46642C60.8123 7.81393 61.4885 7.33475 62.2738 7.11656C63.0591 6.89837 63.901 6.95577 64.6453 7.27825C65.3897 7.60072 65.9868 8.16672 66.3273 8.87266H63.3258C62.9861 8.86785 62.655 8.97416 62.3882 9.17371C62.1214 9.37327 61.9351 9.6539 61.8607 9.96843C61.8156 10.1686 61.8181 10.3758 61.8679 10.575C61.9178 10.7741 62.0137 10.9603 62.1488 11.1199C62.2839 11.2795 62.4547 11.4086 62.6489 11.4977C62.8431 11.5869 63.0558 11.6339 63.2716 11.6354H68.1022C68.2905 11.6345 68.4767 11.5984 68.6503 11.5292C68.8239 11.46 68.9814 11.3591 69.1138 11.2321C69.2463 11.1051 69.3511 10.9546 69.4222 10.7892C69.4933 10.6238 69.5294 10.4468 69.5284 10.2681V10.254C69.5328 9.409 69.3489 8.57262 68.9889 7.79971C68.6288 7.02679 68.1007 6.33479 67.4391 5.76903C66.7775 5.20327 65.9974 4.77654 65.1498 4.51679C64.3023 4.25704 63.4065 4.17014 62.5211 4.26178M78.391 5.66501C78.4203 5.49306 78.4113 5.31719 78.3644 5.14878C78.3175 4.98037 78.2339 4.82317 78.119 4.68737C78.004 4.55156 77.8603 4.44017 77.6971 4.36042C77.5339 4.28066 77.3548 4.23431 77.1716 4.22438C77.084 4.22098 76.9939 4.21952 76.9013 4.21952C76.2451 4.17749 75.5888 4.29954 74.9978 4.57348C74.4069 4.84741 73.9021 5.26364 73.5338 5.78061C73.5355 5.44988 73.3988 5.13203 73.1536 4.89694C72.9084 4.66185 72.5749 4.52878 72.2263 4.52698H71.7215C71.373 4.52878 71.0394 4.66185 70.7942 4.89694C70.549 5.13203 70.4123 5.44988 70.4141 5.78061V14.7372C70.4123 15.0679 70.549 15.3858 70.7942 15.6208C71.0394 15.8559 71.373 15.989 71.7215 15.9908H72.3261C72.4988 15.99 72.6695 15.9569 72.8287 15.8934C72.9879 15.83 73.1323 15.7374 73.2538 15.621C73.3752 15.5046 73.4713 15.3666 73.5366 15.215C73.6019 15.0633 73.635 14.901 73.6341 14.7372V9.74549C73.6341 8.04209 74.658 7.16683 76.1508 7.16683C76.3775 7.16775 76.6039 7.18284 76.8286 7.21201C77.1717 7.25835 77.5202 7.17421 77.7983 6.97789C78.0763 6.78158 78.2614 6.48899 78.3132 6.16383L78.391 5.66501Z" fill="#635CA8"/>
        </svg>
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          class="watch-video sign-up-mobile-top-bar-actions"
        >
          <button type="button" class="watch-video-btn" (click)="onOpenVideo()">
            <span class="watch-video-text">{{ 'WatchVideo' | translate }}</span>
            <span class="watch-video-icon-container">
              <span class="watch-video-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-play"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"
                  />
                </svg>
              </span>
            </span>
          </button>
          <lib-language [color]="'#fff'"></lib-language>
        </div>
      </header>

      <div class="flex items-center justify-start">
        <div (click)="onCloseSidenav()" class="me-[12px] h-[18px] w-[18px] rounded-full bg-[#F9F9FA] flex items-center justify-center hover:bg-[#EDEDED] cursor-pointer transition-colors duration-200">
          <svg [ngClass]="dir == 'ar' ? 'rotate-180' : ''" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.90625 0.28125L0.28125 2.90622M0.28125 2.90622L2.90625 5.53122M0.28125 2.90622H7.03125" stroke="#2F384C" stroke-width="0.5625" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <p class="m-0 font-[500] text-[16px] text-[#000]">verification code</p>
      </div>
      
      <app-verification
        [isVerifyRoute]="isVerifyRoute"
        [inlineRegistrationCycleLogId]="inlineRegistrationCycleLogIdForVerification"
        [inlineUser]="inlineUserForVerification"
        [inlineVerifyType]="verificationData?.verifyType"
        (closeSidebar)="onCloseSidebarFromVerification()"
      ></app-verification>
    </div>

    <section
      *ngIf="!showVerificationInline"
      class="sign-up-layout"
      fxLayout="row"
      fxLayoutAlign="start stretch"
    >
      <!-- Right Part -->
      <div
        class="sign-up-slider-part"
        [ngClass]="dir === 'ar' ? 'slider-ar' : 'slider-en'"
        fxFlex="40"
      >
        <img
          class="sign-up-slider-hero-img"
          [src]="dir === 'ar' ? 'assets/img/signup_ar.png' : 'assets/img/signup.png'"
          alt=""
        />
        <div class="sign-up-slider-topbar">
          <img
            class="sign-up-logo sign-up-logo--topbar"
            src="assets/img/glameraTradeMarkLogo.png"
            width="190"
            alt=""
            title=""
          />
          <div
            class="watch-video sign-up-slider-topbar-actions"
            [attr.dir]="dir"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="8px"
          >
            <button type="button" class="watch-video-btn" (click)="onOpenVideo()">
              <span class="watch-video-text">{{ 'WatchVideo' | translate }}</span>
              <span class="watch-video-icon-container">
                <span class="watch-video-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-play"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"
                    />
                  </svg>
                </span>
              </span>
            </button>
            <lib-language [color]="'#fff'"></lib-language>
          </div>
        </div>
        <img
          class="sign-up-logo sign-up-logo--desktop"
          src="assets/img/glameraTradeMarkLogo.png"
          width="190px"
          alt=""
          title=""
        />
        <main class="signup-main">
          <h2>{{ 'welocme_to_glamera' | translate }}</h2>
          <div class="d-flex text-center" style="white-space: pre-line;">
            <p>{{ 'ADOBT_GLAMERA' | translate }}</p>
          </div>
        </main>
      </div>
      <!-- Form Part -->
      <form
        class="sign-up-form"
        fxFlex="60"
        fxFlex.lt-md="100"
        fxLayout="column"
        fxLayoutAlign="start stretch"
        (submit)="onSubmit()"
        [formGroup]="form"
      >
        <div fxLayout="row" fxLayoutAlign="end center" class="watch-video sign-up-form-toolbar">
          <button type="button" class="watch-video-btn" (click)="onOpenVideo()">
            <span class="watch-video-text">{{ 'WatchVideo' | translate }}</span>
            <span class="watch-video-icon-container">
              <span class="watch-video-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-play"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M10.804 8 5 4.633v6.734zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696z"
                  />
                </svg>
              </span>
            </span>
          </button>
          <lib-language></lib-language>
        </div>

        <div class="fields-container">
          <main class="title-simple-steps">
            <h1>
              {{ 'START_YOUR_BUSINESS' | translate }}
            </h1>
            <p class="mb-0">{{ 'SIMPLE_STEPS' | translate }}</p>
          </main>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">{{ 'FULL_NAME' | translate }}</mat-label>
            <mat-form-field appearance="outline" class="br-20">
              <input
                matInput
                [placeholder]="'ENTER_FULL_NAME' | translate"
                formControlName="FirstName"
                [maxLength]="50"
              />
              <mat-error>
                <app-error-form
                  [name]="'FULL_NAME'"
                  [control]="form.controls['FirstName']"
                  [minLength]="2"
                  [maxLength]="50"
                ></app-error-form>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">{{ 'EMAIL' | translate }}</mat-label>
            <mat-form-field class="example-full-width" appearance="outline">
              <input
                type="email"
                matInput
                [placeholder]="'Enter_your_email' | translate"
                formControlName="Email"
              />
              <mat-error>
                <app-error-form
                  [name]="'EMAIL'"
                  [control]="form.controls['Email']"
                ></app-error-form>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">
              {{ 'AUTH.PHONE_NUMBER' | translate }}
            </mat-label>
            <div
              class="phone-row"
              fxLayout="row"
              fxLayoutAlign="start start"
              fxLayoutGap="10px"
            >
              <ng-container *ngIf="!countriesLoading; else phoneCountrySkeleton">
                <mat-form-field class="phone-country-code" appearance="outline">
                  <mat-select formControlName="CountryId">
                    <mat-select-trigger>
                      <ng-container *ngIf="form.controls['CountryId'].value">
                        <div class="d-flex align-items-center">
                          <img
                            style="border: 1px solid #ddd;"
                            [src]="getSelectedCountry()?.FlagPath"
                            width="24px"
                            alt=""
                          />
                          <span class="mx-1 text-xl">{{ getSelectedCountry()?.CallingCode }}</span>
                        </div>
                      </ng-container>
                    </mat-select-trigger>
                    <mat-option
                      *ngFor="let country of countries"
                      [value]="country.Id"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          style="border: 1px solid #ddd;"
                          [src]="country.FlagPath"
                          width="24px"
                          alt=""
                        />
                        <span class="mx-1 text-xl">{{ country.CallingCode }}</span>
                      </div>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <ng-template #phoneCountrySkeleton>
                <div class="phone-country-code phone-country-code-skeleton"></div>
              </ng-template>

              <mat-form-field class="phone-number-input" appearance="outline">
                <input
                  matInput
                  [placeholder]="'ENTER_PHONE_NUMBER' | translate"
                  formControlName="MobileNumber"
                  [maxLength]="12"
                  appNumberOnly
                />
                <mat-error>
                  <app-error-form
                    [name]="'PHONE_NUMBER'"
                    [control]="form.controls['MobileNumber']"
                    [maxLength]="12"
                    [minLength]="4"
                  ></app-error-form>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="mb-[2px]">
            <mat-label class="label">{{ 'PASSWORD' | translate }}</mat-label>
            <mat-form-field appearance="outline">
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                formControlName="Password"
                [placeholder]="'ENTER_PASSWORD' | translate"
                [maxLength]="20"
              />
              <button
                mat-icon-button
                matSuffix
                (click)="hide = !hide"
                [attr.aria-label]="hide ? 'Show password' : 'Hide password'"
                [attr.aria-pressed]="hide"
                type="button"
              >
                @if (hide) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-eye"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z"
                    />
                    <path
                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0"
                    />
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-eye-slash"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7 7 0 0 0-2.79.588l.77.771A6 6 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755q-.247.248-.517.486z"
                    />
                    <path
                      d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829"
                    />
                    <path
                      d="M3.35 5.47q-.27.24-.518.487A13 13 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7 7 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12z"
                    />
                  </svg>
                }
              </button>
              <mat-error *ngIf="isPasswordInvalid">
                <app-error-form
                  [name]="'PASSWORD'"
                  [control]="form.controls['Password']"
                  [maxLength]="20"
                  [minLength]="6"
                ></app-error-form>
              </mat-error>
              <mat-error
                *ngIf="
                  form.controls['Password'].hasError('pattern') &&
                  (form.controls['Password'].dirty || form.controls['Password'].touched)
                "
              >
                {{ 'PASSWORD_MUST_CONTAIN_LETTERS_AND_NUMBERS' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="column" fxLayoutAlign="start stretch" class="bt-1 mt-0">
            <mat-checkbox
              class="terms-conditions"
              formControlName="AgreeToPrivacyPolicy"
              color="primary"
            >
              <span>
                {{ 'AGREE_WITH' | translate }}
                <a
                  (click)="onOpenPrivacy($event)"
                  class="privacy"
                  >{{ 'PRIVACY_POLICY' | translate }}</a
                >
                {{ 'AND' | translate }}
                <a
                  (click)="onOpenPrivacy($event)"
                  class="terms-link"
                  >{{ 'TERMS_CONDITIONS' | translate }}</a
                >
              </span>
            </mat-checkbox>

            <button
              color="primary"
              type="submit"
              class="submit-btn"
              [disabled]="form.invalid || loading"
            >
              {{ 'SIGN_UP' | translate }}
              <span class="btn-spinner-icon" *ngIf="loading"></span>
            </button>
          </div>

          <div class="login">
            <p>
              {{ 'HAVE_ACCOUNT' | translate }}
              <a class="text-xl" [href]="'https://' + appDomain + '/' + config.routes.LOGIN">{{
                'Login' | translate
              }}</a>
            </p>
          </div>
        </div>
      </form>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
